import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import '../assets/css/HomePage.css';
import { bon1, bon2, bon3 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ------------- SEO helpers ------------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// Порядок атрибутов: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Bonuses = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

useEffect(() => {
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // ===== Тексты (EN → BN перевод готов) =====
  const pageTitleEN = "HHBD Promotions — Exclusive Casino & Sports Offers BD";
  const pageDescEN =
    "Unlock HHBD bonuses and win more! Claim free spins, cashback, and VIP rewards in BDT. Get your 100% welcome package and enjoy daily promotions built for Bangladeshi casino & sports players.";

  const pageTitleBN = "HHBD প্রচারণা — এক্সক্লুসিভ ক্যাসিনো এবং স্পোর্টস অফার BD";
  const pageDescBN =
    "বাংলাদেশের খেলোয়াড়দের জন্য ডিজাইন করা HHBD বোনাস আনলক করুন! বিনামূল্যে স্পিন, ক্যাশব্যাক এবং বাংলাদেশী টাকায় ভিআইপি সুবিধা দাবি করুন। উদার স্বাগত প্যাকেজ এবং সাপ্তাহিক পুরষ্কার উপভোগ করুন যা প্রতিটি স্পিন এবং বাজিকে আরও লাভজনক করে তোলে।";

  const pageKeywordsEN =
    "HHBD Bonuses, casino bonus BD, free spins Bangladesh, cashback offer BD, welcome bonus BD, VIP rewards";
  const pageKeywordsBN =
    "HHBD বোনাস, ফ্রি স্পিন, ক্যাশব্যাক অফার, ভিআইপি রিওয়ার্ড, ওয়েলকাম বোনাস, এক্সক্লুসিভ প্রোমো বাংলাদেশ";

  const isBN = lang === "bn";

  // ===== Требование: все ТАЙТЛЫ (обычные) и МИКРОРАЗМЕТКА — UPPERCASE =====
  const pageTitle = (isBN ? pageTitleBN : pageTitleEN).toUpperCase(); // тайтл сразу в верхнем регистре
  const pageDesc = isBN ? pageDescBN : pageDescEN;                    // description — обычный регистр
  const pageKeywords = isBN ? pageKeywordsBN : pageKeywordsEN;        // keywords — обычный регистр

  // <title> + базовые мета
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaName("description", pageDesc);       // обычный регистр
  setMetaName("keywords", pageKeywords);      // обычный регистр

  // Canonical + hreflang (+ x-default → en)
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // -------- Open Graph --------
  const ogImage = toAbsoluteUrl(bon1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);          // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc);     // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? pageTitleBN : pageTitleEN); // alt — читаемый
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // -------- Twitter (тайтл в UPPERCASE + twitter:url) --------
  const twitterSite = "@HHBD_official";     // ← замени на реальный @ бренда
  const twitterCreator = "@HHBD_official";  // ← или автора
  const twitterImageAlt = isBN
    ? "HHBD বোনাস - আপনার ব্যালেন্স তাৎক্ষণিকভাবে বাড়াতে স্বাগতম অফার, ক্যাশব্যাক পুরস্কার এবং ফ্রি স্পিন নিন।"
    : "HHBD Bonuses – grab welcome offers, cashback rewards and free spins to boost your balance instantly.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);         // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);    // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);       // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // label/data пары (до двух)
  setMetaName("twitter:label1", isBN ? "বোনাসের ধরন" : "Bonus Types");
  setMetaName("twitter:data1", isBN ? "ওয়েলকাম, ফ্রি স্পিন, ক্যাশব্যাক, VIP" : "Welcome, Free Spins, Cashback, VIP");
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");

  // -------- JSON-LD (всё, что в микроразметке — UPPERCASE) --------

}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/bonuses";

      // Visible copy (keep JSON-LD NAME/DESCRIPTION uppercased to match your rule)
      const titleEN = "HHBD Promotions — Exclusive Casino & Sports Offers BD";
      const descEN =
        "Unlock HHBD bonuses and win more! Claim free spins, cashback, and VIP rewards in BDT. Get your 100% welcome package and enjoy daily promotions built for Bangladeshi casino & sports players.";

      const titleBN = "HHBD প্রচারণা — এক্সক্লুসিভ ক্যাসিনো এবং স্পোর্টস অফার BD";
      const descBN =
        "বাংলাদেশের খেলোয়াড়দের জন্য ডিজাইন করা HHBD বোনাস আনলক করুন! বিনামূল্যে স্পিন, ক্যাশব্যাক এবং বাংলাদেশী টাকায় ভিআইপি সুবিধা দাবি করুন। উদার স্বাগত প্যাকেজ এবং সাপ্তাহিক পুরষ্কার উপভোগ করুন যা প্রতিটি স্পিন এবং বাজিকে আরও লাভজনক করে তোলে।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";

      // Organization description (uppercased in microdata)

      // Choose a primary image (bon1), resolve to absolute
      const ogImage =
        typeof bon1 === "string"
          ? (/^https?:\/\//i.test(bon1) ? bon1 : `${origin}${bon1.startsWith("/") ? "" : "/"}${bon1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage (Promotions / Bonuses)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {bon1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl per request)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
 <>
    <section className="zHHBD-bonushero">
      {/* background */}
      <div className="zHHBD-bonushero__bg">
        <div className="zHHBD-bonushero__overlay"></div>
        <div className="zHHBD-bonushero__flare zHHBD-bonushero__flare--1"></div>
        <div className="zHHBD-bonushero__flare zHHBD-bonushero__flare--2"></div>
      </div>
      {/* content */}
      <div className="zHHBD-bonushero__container">
        <div className="zHHBD-bonushero__content">
          <h1 className="zHHBD-bonushero__title">
            HHBD Bonuses – Free Spins, Cashback & VIP Rewards
          </h1>
          <p className="zHHBD-bonushero__desc">
            Enter HHBD’s rewards hub — a living stream of promotions where rotating deals, 
            member-first drops, and clean, stackable boosters elevate every visit from your first sign-in 
            to the final spin before bedtime. Trigger daily accelerators, lock in dependable reload bundles, 
            and claim Bangladesh-ready spin sets in just a few taps. Whether it’s your debut or your thousandth session, 
            a tailored offer is queued up and ready. Stay in rhythm with reliable spin showers, weekly cashback bursts, 
            and a tiered VIP path that unlocks bigger thrills, stronger value, and frequent upgrade windows — delivered 
            quickly, clearly, and with steady consistency from start to finish.
          </p>
          <div className="zHHBD-bonushero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bonushero__btn zHHBD-bonushero__btn--main"
              title="Activate a HHBD offer now and squeeze the most value from today’s complete bonus catalog"
            >
              Claim My Bonus Now
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bonushero__btn zHHBD-bonushero__btn--ghost"
              title="Install the HHBD app to browse, redeem, and track rewards anywhere in Bangladesh without friction"
            >
              Download App
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="A live peek at HHBD’s current promotions with a constantly refreshing ribbon of new opportunities"
        >
          <img
            src={bon1}
            alt="HHBD rewards spotlight — curated picks with day-by-day specials sliding into view from morning to night."
            title="HHBD highlights — today’s featured bonuses alongside an always-updating promotions carousel"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-welcome">
      <canvas className="zHHBD-welcome__hex" id="hexGrid"></canvas>
      <div className="zHHBD-welcome__confetti">
        <span className="confetti confetti--1"></span>
        <span className="confetti confetti--2"></span>
        <span className="confetti confetti--3"></span>
      </div>
      <div className="zHHBD-welcome__ring zHHBD-welcome__ring--a"></div>
      <div className="zHHBD-welcome__ring zHHBD-welcome__ring--b"></div>
      <div className="zHHBD-welcome__cube">
        <div className="zHHBD-welcome__cube-face zHHBD-welcome__cube-face--front">
          <header className="zHHBD-welcome__header">
            <h2 className="zHHBD-welcome__title">
              HHBD Welcome Bundle — Kickstart Strong with High-Energy Launch Boosts
            </h2>
          </header>
          <div className="zHHBD-welcome__body">
            <p className="zHHBD-welcome__text">
              First time at HHBD? Power up with a high-impact starter kit. We’ll match your opening deposit, 
              let you spin flagship <Link to="/slots" className="zHHBD-welcome__link">slot games</Link> using bonus credit, 
              and secure cashback tuned to your style — simply for registering and getting underway immediately.
            </p>
            <p className="zHHBD-welcome__text">
              Your perks adapt to you. Prefer <Link to="/slots" className="zHHBD-welcome__link">slots</Link>? 
              Collect free spins and tour headline releases. Enjoy the composed pace of
              <Link to="/casino" className="zHHBD-welcome__link"> casino</Link> tables or the tactical rush of 
              <Link to="/bet" className="zHHBD-welcome__link"> sports bets</Link>? Unlock reload boosts and cashback 
              that mirror your cadence. No codes, no hurdles — everything fires automatically the moment you arrive.
            </p>
            <p className="zHHBD-welcome__text">
              Deposit via bKash, Nagad, or Rocket and watch bonuses trigger the instant your BDT lands — 
              quick, seamless, and straightforward from your very first top-up, with nothing extra required.
            </p>
            <p className="zHHBD-welcome__text">
              Your edge travels wherever you play. Slot lovers bank spins. Cricket and football fans receive 
              extra stake credit and boosted returns. Table regulars enjoy rolling cashback — a steady stream 
              of fresh advantages each session without losing momentum.
            </p>
            <div className="zHHBD-welcome__cards">
              <div className="zHHBD-welcome__card">🎁 100% Match Bonus on Your First Deposit</div>
              <div className="zHHBD-welcome__card">🎰 Free Spins on Bangladesh-Favorite Slots</div>
              <div className="zHHBD-welcome__card">🏏 Free Bets for Must-Watch Cricket &amp; Football</div>
              <div className="zHHBD-welcome__card">🕹️ Coverage for Slots, Crash, Live Casino &amp; Sports</div>
              <div className="zHHBD-welcome__card">💵 Rapid, Reliable BDT Withdrawals</div>
            </div>
            <p className="zHHBD-welcome__text">
              Benefits kick in instantly with clear terms, brisk payouts, and 24/7 Bengali support — 
              the perfect runway for your HHBD journey, starting now and cruising confidently all season long.
            </p>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-welcome__btn"
              title="Activate your HHBD welcome bundle today and launch with a confident, high-powered start"
            >
              Unlock My Welcome Package Today
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-reload">
      <div className="zHHBD-reload__shimmer zHHBD-reload__shimmer--1"></div>
      <div className="zHHBD-reload__shimmer zHHBD-reload__shimmer--2"></div>
      <div className="zHHBD-reload__wrapper">
        <div className="zHHBD-reload__visual">
          <figure className="zHHBD-reload__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD VIP Club visuals — rising tiers paired with elevated loyalty privileges at every stage"
            >
              <img
                src={bon2}
                alt="HHBD VIP &amp; loyalty insignia — exclusivity, status, and premium advantages for committed members."
                title="HHBD VIP — structured ranks with meaningful, high-impact perks revealed at each level of your ascent"
                className="zHHBD-reload__img"
              />
            </a>
          </figure>
        </div>
        <div className="zHHBD-reload__content">
          <h2 className="zHHBD-reload__title">
            VIP &amp; Loyalty — Rise Through the Ranks and Unlock More at Every Step
          </h2>
          <p className="zHHBD-reload__text">
            Every <Link to="/bet" className="zHHBD-reload__link">bet</Link>,{" "}
            <Link to="/games" className="zHHBD-reload__link">game</Link>, and spin moves you closer to elite status.
            Climb HHBD’s five-tier journey — Bronze, Silver, Gold, Platinum, then Diamond — with each milestone unveiling
            richer, more tailored benefits as you progress.
          </p>
          <p className="zHHBD-reload__text">
            The higher you go, the better the treatment — boosted cashback, priority hosts, accelerated withdrawals, 
            surprise drops, private invitations, and celebratory birthday bonuses. No forms and no codes — simply play, 
            and watch upgrades land automatically while you enjoy uninterrupted action end-to-end.
          </p>
          <ul className="zHHBD-reload__text list-reset">
            <li>💎 <strong>Five Distinct Tiers</strong> — Bronze • Silver • Gold • Platinum • Diamond</li>
            <li>🎁 <strong>Personalized Rewards</strong> aligned with your preferences and play tempo</li>
            <li>⚡ <strong>Priority Support &amp; Lightning Payouts</strong> exactly when they matter most</li>
            <li>🎂 <strong>Exclusive Gifts &amp; Birthday Treats</strong> delivered with polish and flair</li>
            <li>📈 <strong>VIP Progress Dashboard</strong> for instant, at-a-glance tracking of your ascent</li>
          </ul>
          <p className="zHHBD-reload__text">
            VIP is more than a badge — it’s your fast lane to premium care, stronger returns, and constant surprises. 
            For Bangladesh’s most devoted players, this path rewards both value and experience in equal measure.
          </p>
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-reload__btn"
            title="Join HHBD VIP today and unlock top-tier advantages without delays, hurdles, or extra steps"
          >
            Enter the VIP Club
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-vip">
      <div className="zHHBD-vip__halo">
        <span className="zHHBD-vip__halo-ring zHHBD-vip__halo-ring--a"></span>
        <span className="zHHBD-vip__halo-ring zHHBD-vip__halo-ring--b"></span>
      </div>
      <figure className="zHHBD-vip__figure">
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD’s daily and weekly incentives designed with loyal members at the heart of every decision"
        >
          <img
            src={bon3}
            alt="HHBD loyalty gallery — everyday bonuses with a rotating carousel of weekly headliners."
            title="HHBD rewards wall — today’s daily offers beside a rolling weekly calendar of marquee picks"
            className="zHHBD-vip__img"
          />
        </a>
      </figure>
      <div className="zHHBD-vip__card">
        <h2 className="zHHBD-vip__title">
          Daily Drops &amp; Weekly Headliners — HHBD Keeps Value Always in Motion
        </h2>
        <p className="zHHBD-vip__text">
          With HHBD, fresh extras arrive every single day — there’s always a reason to jump back in. 
          Collect Monday cashback, join Tuesday crash competitions, glide into Friday free spins, 
          and close the week with inventive Sunday reloads. Each week reveals new ways to grow your BDT balance 
          and keep momentum without skipping a beat.
        </p>
        <ul className="zHHBD-vip__text list-reset">
          <li>🎯 <strong>Monday</strong>: Cashback cushions and recovery boosts to steady your stride for the days ahead</li>
          <li>🎲 <strong>Tuesday</strong>: Free-entry crash events with real prizes and scoreboard bragging rights</li>
          <li>🎰 <strong>Friday</strong>: Free spins featuring trending slot releases and hot new titles ready to play</li>
          <li>💥 <strong>Sunday</strong>: Reload bonuses with smart twists to fuel the coming week with purpose and poise</li>
        </ul>
        <p className="zHHBD-vip__text">
          Dive into slot races, deposit missions, and leaderboard challenges to scoop extra value on demand. 
          Seasonal specials and festive campaigns sprinkle win chances all year — variety and excitement baked in.
        </p>
        <p className="zHHBD-vip__text">
          Best of all, it’s effortless — no codes and no hassle. Rewards credit straight to your account. 
          Check in daily to catch the newest drops and never miss a moment. With HHBD, everyday extras are 
          woven into the experience and built to carry you forward with confidence.
        </p>
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-vip__btn"
          title="Open HHBD’s live bonus calendar and explore today’s featured deals in complete detail"
        >
          Browse Today’s Bonus Deals
        </a>
      </div>
    </section>
  </>
      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
  <>
    <section className="zHHBD-bonushero">
      {/* পটভূমি */}
      <div className="zHHBD-bonushero__bg">
        <div className="zHHBD-bonushero__overlay"></div>
        <div className="zHHBD-bonushero__flare zHHBD-bonushero__flare--1"></div>
        <div className="zHHBD-bonushero__flare zHHBD-bonushero__flare--2"></div>
      </div>
      {/* বিষয়বস্তু */}
      <div className="zHHBD-bonushero__container">
        <div className="zHHBD-bonushero__content">
          <h1 className="zHHBD-bonushero__title">
            HHBD বোনাস - ফ্রি স্পিন, ক্যাশব্যাক এবং ভিআইপি পুরস্কার
          </h1>
          <p className="zHHBD-bonushero__desc">
            HHBD-এর রিওয়ার্ডস হাবে স্বাগতম — যেখানে ঘূর্ণায়মান ডিল, মেম্বার-ফার্স্ট ড্রপস এবং পরিষ্কার, স্ট্যাকে যোগ হওয়া বুস্টারগুলো
            আপনার প্রথম সাইন-ইন থেকে রাতের শেষ স্পিন পর্যন্ত প্রতিটি ভিজিটকে আরও উঁচুতে তুলে ধরে।
            প্রতিদিনের অ্যাক্সেলারেটর আনলক করুন, নির্ভরযোগ্য রিলোড বান্ডেল নিশ্চিত করুন,
            এবং মাত্র কয়েকটি ট্যাপে বাংলাদেশ-প্রস্তুত স্পিন সেট দাবি করুন।
            এটি আপনার প্রথম দিন হোক বা হাজারতম সেশন—একটি ব্যক্তিগতকৃত অফার সারিবদ্ধ হয়ে আপনার অপেক্ষায়।
            নিয়মিত স্পিন শাওয়ার, সাপ্তাহিক ক্যাশব্যাক বার্স্ট, আর টিয়ারভিত্তিক VIP পথ—যা বড় রোমাঞ্চ, বেশি ভ্যালু এবং ঘন ঘন আপগ্রেড উইন্ডো খুলে দেয়—
            সবকিছুই দ্রুত, পরিষ্কার ও শুরু থেকে শেষ পর্যন্ত স্থির ধারাবাহিকতায় সরবরাহ করা হয়।
          </p>
          <div className="zHHBD-bonushero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bonushero__btn zHHBD-bonushero__btn--main"
              title="এখনই একটি HHBD অফার অ্যাক্টিভ করুন এবং আজকের পূর্ণ বোনাস ক্যাটালগ থেকে সর্বোচ্চ ভ্যালু নিন"
            >
              এখনই আমার বোনাস নিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bonushero__btn zHHBD-bonushero__btn--ghost"
              title="বাংলাদেশে যেখানেই থাকুন—বিনা ঝামেলায় ব্রাউজ, রিডিম ও ট্র্যাক করতে HHBD অ্যাপ ইনস্টল করুন"
            >
              অ্যাপ ডাউনলোড করুন
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD-এর চলমান প্রোমোশন—নতুন সুযোগের রিবন যা ক্রমাগত রিফ্রেশ হয়—তার লাইভ ঝলক"
        >
          <img
            src={bon1}
            alt="HHBD রিওয়ার্ডস স্পটলাইট — প্রতিদিনের বিশেষ অফারগুলোর কিউরেটেড হাইলাইটস সকাল থেকে রাত পর্যন্ত টিকার আকারে এগিয়ে চলেছে।"
            title="HHBD হাইলাইটস — আজকের ফিচারড বোনাস এবং সর্বদা আপডেট হওয়া প্রোমোশনস ক্যারোজেল"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-welcome">
      <canvas className="zHHBD-welcome__hex" id="hexGrid"></canvas>
      <div className="zHHBD-welcome__confetti">
        <span className="confetti confetti--1"></span>
        <span className="confetti confetti--2"></span>
        <span className="confetti confetti--3"></span>
      </div>
      <div className="zHHBD-welcome__ring zHHBD-welcome__ring--a"></div>
      <div className="zHHBD-welcome__ring zHHBD-welcome__ring--b"></div>
      <div className="zHHBD-welcome__cube">
        <div className="zHHBD-welcome__cube-face zHHBD-welcome__cube-face--front">
          <header className="zHHBD-welcome__header">
            <h2 className="zHHBD-welcome__title">
              HHBD ওয়েলকাম বান্ডেল — হাই-এনার্জি লঞ্চ বুস্ট দিয়ে শক্তিশালী সূচনা
            </h2>
          </header>
          <div className="zHHBD-welcome__body">
            <p className="zHHBD-welcome__text">
              HHBD-এ প্রথমবার? হাই-ইমপ্যাক্ট স্টার্টার কিট দিয়ে শক্তি বাড়িয়ে নিন।
              আমরা আপনার প্রথম ডিপোজিট ম্যাচ করব,
              বোনাস ক্রেডিট দিয়ে ফ্ল্যাগশিপ{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লট</Link> {" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> ঘোরাতে দেব,
              আর আপনার স্টাইলে টিউন করা ক্যাশব্যাক লক করে দেব — কেবল রেজিস্টার করে এখনই শুরু করলেই।
            </p>
            <p className="zHHBD-welcome__text">
              সুবিধাগুলো আপনার সাথে মানিয়ে যায়।{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লট</Link> পছন্দ?
              ফ্রি স্পিন সংগ্রহ করুন এবং হেডলাইন রিলিজগুলো ঘুরে দেখুন।
              স্থির ছন্দের{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> টেবিল বা ট্যাকটিক্যাল
              {" "}<Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস বেট</Link> ভালো লাগে?
              রিলোড বুস্ট ও ক্যাশব্যাক আনলক করুন যা আপনার কেডেন্সের সাথে তাল মিলিয়ে চলে।
              কোনো কোড নয়, অতিরিক্ত ধাপও নয় — আপনি পৌঁছানো মাত্র সবকিছু নিজে থেকেই চালু।
            </p>
            <p className="zHHBD-welcome__text">
              bKash, Nagad বা Rocket দিয়ে ডিপোজিট করুন এবং আপনার BDT পৌঁছাতেই বোনাস ট্রিগার হতে দেখুন —
              প্রথম টপ-আপ থেকেই দ্রুত, নির্ঝঞ্ঝাট ও একেবারে সোজা, অতিরিক্ত কিছু লাগবে না।
            </p>
            <p className="zHHBD-welcome__text">
              আপনি যেখানে খেলুন, সুবিধাগুলো সেখানেই যাবে।
              স্লটপ্রেমীরা স্পিন পাবে। ক্রিকেট ও ফুটবল অনুরাগীরা অতিরিক্ত স্টেক ক্রেডিট ও বুস্টেড রিটার্ন পায়।
              টেবিল রেগুলাররা রোলিং ক্যাশব্যাক উপভোগ করেন — প্রতিটি সেশনে ধারাবাহিক নতুন সুবিধা, গতি না হারিয়ে।
            </p>
            <div className="zHHBD-welcome__cards">
              <div className="zHHBD-welcome__card">🎁 প্রথম ডিপোজিটে 100% ম্যাচ বোনাস</div>
              <div className="zHHBD-welcome__card">🎰 বাংলাদেশের প্রিয় স্লটে ফ্রি স্পিন</div>
              <div className="zHHBD-welcome__card">🏏 অবশ্য-দেখা ক্রিকেট ও ফুটবলে ফ্রি বেট</div>
              <div className="zHHBD-welcome__card">🕹️ স্লট, ক্র্যাশ, লাইভ ক্যাসিনো ও স্পোর্টস—সবই কভারেজ</div>
              <div className="zHHBD-welcome__card">💵 দ্রুত, নির্ভরযোগ্য BDT উত্তোলন</div>
            </div>
            <p className="zHHBD-welcome__text">
              পরিষ্কার শর্ত, চটপট পেআউট, আর 24/7 বাংলা সাপোর্ট—এই সব মিলিয়ে এখনই আপনার HHBD যাত্রার নিখুঁত রানওয়ে,
              পুরো মৌসুম জুড়ে আত্মবিশ্বাসে এগিয়ে চলতে শুরু করুন।
            </p>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-welcome__btn"
              title="আজই আপনার HHBD ওয়েলকাম বান্ডেল সক্রিয় করুন এবং আত্মবিশ্বাসী, শক্তিশালী শুরু করুন"
            >
              আজই আমার ওয়েলকাম প্যাকেজ আনলক করুন
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-reload">
      <div className="zHHBD-reload__shimmer zHHBD-reload__shimmer--1"></div>
      <div className="zHHBD-reload__shimmer zHHBD-reload__shimmer--2"></div>
      <div className="zHHBD-reload__wrapper">
        <div className="zHHBD-reload__visual">
          <figure className="zHHBD-reload__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD VIP ক্লাব—প্রতি স্তরে বাড়তি লয়্যালটি সুবিধাসহ উর্ধ্বমুখী অগ্রযাত্রার ভিজ্যুয়ালস"
            >
              <img
                src={bon2}
                alt="HHBD VIP ও লয়্যালটি ইন্সিগনিয়া — এক্সক্লুসিভিটি, স্ট্যাটাস এবং নিবেদিত সদস্যদের জন্য প্রিমিয়াম সুবিধা।"
                title="HHBD VIP — স্তরভিত্তিক র‌্যাঙ্ক যেখানে প্রতিটি ধাপে তাৎপর্যপূর্ণ, হাই-ইমপ্যাক্ট পার্কস উন্মোচিত হয়"
                className="zHHBD-reload__img"
              />
            </a>
          </figure>
        </div>
        <div className="zHHBD-reload__content">
          <h2 className="zHHBD-reload__title">
            VIP &amp; লয়্যালটি — স্তর পেরিয়ে উঠুন, প্রতিটি ধাপে আনলক করুন আরো বেশি
          </h2>
          <p className="zHHBD-reload__text">
            প্রতিটি{" "}
            <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস বেট</Link>,{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> ও স্পিন আপনাকে এলিট স্ট্যাটাসের আরও কাছে নিয়ে যায়।
            HHBD-এর পাঁচ-স্তরের যাত্রা — Bronze, Silver, Gold, Platinum, তারপর Diamond — যেখানে প্রতিটি মাইলস্টোনে
            আরও সমৃদ্ধ ও আপনার জন্য মানানসই সুবিধা উন্মুক্ত হয়।
          </p>
          <p className="zHHBD-reload__text">
            যত ওপরে উঠবেন, তত ভালো ট্রিটমেন্ট — বুস্টেড ক্যাশব্যাক, প্রাইওরিটি হোস্ট, দ্রুততর উইথড্রয়াল,
            সারপ্রাইজ ড্রপস, ব্যক্তিগত আমন্ত্রণ আর জন্মদিনের বোনাস।
            কোনো ফর্ম নয়, কোনো কোড নয় — কেবল খেলুন, আর আপগ্রেডগুলো স্বয়ংক্রিয়ভাবে এসে পড়বে; শুরু থেকে শেষ পর্যন্ত বাধাহীন অভিজ্ঞতা।
          </p>
          <ul className="zHHBD-reload__text list-reset">
            <li>💎 <strong>পাঁচটি স্বতন্ত্র টিয়ার</strong> — Bronze • Silver • Gold • Platinum • Diamond</li>
            <li>🎁 <strong>পার্সোনালাইজড রিওয়ার্ডস</strong> — আপনার পছন্দ ও খেলার কেডেন্সের সাথে মিল রেখে</li>
            <li>⚡ <strong>প্রাইওরিটি সাপোর্ট &amp; লাইটনিং পেআউট</strong> — যখন সবচেয়ে বেশি দরকার</li>
            <li>🎂 <strong>এক্সক্লুসিভ গিফটস &amp; জন্মদিনের ট্রিটস</strong> — আভিজাত্য ও যত্নে ডেলিভার্ড</li>
            <li>📈 <strong>VIP প্রগ্রেস ড্যাশবোর্ড</strong> — এক নজরেই আপনার অগ্রগতি ট্র্যাক করুন</li>
          </ul>
          <p className="zHHBD-reload__text">
            VIP কেবল একটি ব্যাজ নয় — এটা আপনার প্রিমিয়াম কেয়ার, শক্তিশালী রিটার্ন আর ধারাবাহিক সারপ্রাইজের হাইওয়ে।
            বাংলাদেশের সবচেয়ে নিবেদিত খেলোয়াড়দের জন্য এই পথ ভ্যালু ও এক্সপেরিয়েন্স—দুইয়েরই পুরস্কার দেয়।
          </p>
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-reload__btn"
            title="আজই HHBD VIP-এ যোগ দিন—বিনা বিলম্ব, ঝামেলা বা অতিরিক্ত ধাপ ছাড়াই টপ-টিয়ার সুবিধা আনলক করুন"
          >
            VIP ক্লাবে প্রবেশ করুন
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-vip">
      <div className="zHHBD-vip__halo">
        <span className="zHHBD-vip__halo-ring zHHBD-vip__halo-ring--a"></span>
        <span className="zHHBD-vip__halo-ring zHHBD-vip__halo-ring--b"></span>
      </div>
      <figure className="zHHBD-vip__figure">
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD-এর দৈনিক ও সাপ্তাহিক ইনসেনটিভ—প্রতিটি সিদ্ধান্তের কেন্দ্রে লয়্যাল সদস্যরা"
        >
          <img
            src={bon3}
            alt="HHBD লয়্যালটি গ্যালারি — প্রতিদিনের বোনাস, সাথে সাপ্তাহিক হেডলাইনারদের ঘূর্ণায়মান ক্যারোজেল।"
            title="HHBD রিওয়ার্ডস ওয়াল — আজকের ডেইলি অফারের পাশে সাপ্তাহিক ফিচারগুলোর চলমান ক্যালেন্ডার"
            className="zHHBD-vip__img"
          />
        </a>
      </figure>
      <div className="zHHBD-vip__card">
        <h2 className="zHHBD-vip__title">
          ডেইলি ড্রপস &amp; উইকলি হেডলাইনারস — HHBD সবসময় ভ্যালু গতিশীল রাখে
        </h2>
        <p className="zHHBD-vip__text">
          HHBD-এ প্রতিদিনই নতুন এক্সট্রা পৌঁছে যায় — ফিরে আসার কারণ সবসময়ই থাকে।
          সোমবার ক্যাশব্যাক সংগ্রহ করুন, মঙ্গলবার ক্র্যাশ কম্পিটিশনে যোগ দিন, শুক্রবার ফ্রি স্পিনে গ্লাইড করুন,
          আর রবিবার সৃজনশীল রিলোড দিয়ে সপ্তাহটি শেষ করুন।
          প্রতিটি সপ্তাহেই আপনার BDT ব্যালান্স বড় করার আর গতি ধরে রাখার নতুন উপায় খুঁজে পাবেন।
        </p>
        <ul className="zHHBD-vip__text list-reset">
          <li>🎯 <strong>সোমবার</strong>: সামনে দিনের জন্য স্টেপ স্থির করতে ক্যাশব্যাক কুশন ও রিকভারি বুস্ট</li>
          <li>🎲 <strong>মঙ্গলবার</strong>: ফ্রি-এন্ট্রি ক্র্যাশ ইভেন্ট—রিয়াল পুরস্কার ও স্কোরবোর্ড ব্র্যাগিং রাইটস</li>
          <li>🎰 <strong>শুক্রবার</strong>: ট্রেন্ডিং স্লট রিলিজে ফ্রি স্পিন—খেলার জন্য প্রস্তুত নতুন টাইটেল</li>
          <li>💥 <strong>রবিবার</strong>: স্মার্ট টুইস্টসহ রিলোড বোনাস—আত্মবিশ্বাসে নতুন সপ্তাহ জ্বালানি দিন</li>
        </ul>
        <p className="zHHBD-vip__text">
          স্লট রেস, ডিপোজিট মিশন ও লিডারবোর্ড চ্যালেঞ্জে ঝাঁপিয়ে পড়ুন—চাহিদামতো বাড়তি ভ্যালু তুলুন।
          সিজনাল স্পেশালস ও উৎসবভিত্তিক ক্যাম্পেইনে বছরজুড়ে জয়ের সুযোগ ছিটিয়ে থাকে—বিল্ট-ইন বৈচিত্র্য ও উত্তেজনা।
        </p>
        <p className="zHHBD-vip__text">
          সবচেয়ে ভালো ব্যাপার—এটা নির্ঝঞ্ঝাট। কোনো কোড নয়, কোনো ঝামেলাও নয়।
          রিওয়ার্ডস সরাসরি আপনার অ্যাকাউন্টে ক্রেডিট হয়।
          প্রতিদিন ঢুঁ মেরে নতুন ড্রপ ধরুন—কোনো মুহূর্ত মিস করবেন না।
          HHBD-এ প্রতিদিনের এক্সট্রাগুলো অভিজ্ঞতার অঙ্গ, আর আপনাকে আত্মবিশ্বাসে সামনে এগোতেই তৈরি।
        </p>
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-vip__btn"
          title="HHBD-এর লাইভ বোনাস ক্যালেন্ডার খুলুন এবং আজকের ফিচারড ডিলগুলো সম্পূর্ণ বিস্তারিতভাবে দেখুন"
        >
          আজকের বোনাস ডিল দেখুন
        </a>
      </div>
    </section>
  </>

      )}
    </>
  );
};

export default Bonuses;
